import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Button, FormFeedback } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

import Select from "react-select";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { formatCurrency, formatDate } from '../../Utils/formatters';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const ReferralReward = props => {
  const [modal_Status, setmodal_Status] = useState(false);
  function Status() {
    setmodal_Status(!modal_Status);
    // removeBodyCss();
  }

  const [modal_Status1, setmodal_Status1] = useState(false);
  function Status1() {
    setmodal_Status1(!modal_Status1);
    // removeBodyCss();
  }



  //meta title
  document.title = "Referral Reward";
  const { getRequest, postRequest } = useRequests();

  
  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: {label: 'All', value: 'All'},
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = TransactionData;
        if(values.user.value !== 'All') {
          filteredData = filteredData.filter(item => String(item.u_id) === String(values.user.value));
        }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="7" className="text-center">No records found</td>
                        </tr>);

          setTransactionTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [TransactionData, setTransactionData] = React.useState([]);
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{formatDate(element.created_at)}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{formatCurrency(element.reward_amount)}</td>
        <td>{element.from_first_name} {element.from_last_name} ( {element.from_email} )</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-secondary')}>{element.status}</span></td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  const handleLoadGetTransactionData = async () => {
    const res = await getRequest('get-referral-reward-transaction-data');
    if (res && res.code === 200) {
      handleT1Body(res.data);
      setTransactionData(res.data);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="7" className="text-center">No records found</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }
  
  const [UsersData, setUsersData] = React.useState([]);
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let tempArr = [{label: 'All', value: 'All'}];
      res.data.forEach(element => {
        let temp = {
            label: `${element.first_name} ${element.last_name} (${element.email})`,
            value: element.u_id,
        };
        tempArr.push(temp);
      });
      if (props.match.params.id) {
        let getUser = tempArr.find(element => String(element.value) === String(atob(props.match.params.id)));
        
        validation1.setValues({
          ...validation1.values,
          user: getUser,
        });

        setTimeout(() => {
          validation1.handleSubmit();
        }, 500);
      }
      tempArr = [{
          options: tempArr
      }];
      setUsersData(tempArr);
    }
  }
  React.useEffect(() => {
    handleLoadGetTransactionData();
    handleLoadGetUsers();
  }, []);


  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Referral Reward")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col md={4} xs={12}>
                        <div className="mb-3 Register-Select2">
                          <label className="form-label">Users : </label>
                          <Select styles={colourStyles} value={validation1.values.user} onChange={(e) => validation1.setValues({ ...validation1.values, user: e })} options={UsersData} classNamePrefix="select2-selection" />
                        </div>
                      </Col>

                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label fullWidth">&nbsp; </label>
                          <Button type="button" 
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          color="primary">Search</Button>
                        </div>
                      </Col>
                    </div>
                    <div className="table-responsive mb-0" data-pattern="priority-columns">
                      <table className="table mb-0" style={{ minWidth: "1000px" }}>
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Referral Reward</th>
                            <th>Referral From</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {TransactionTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal className="transation" centered backdrop="static" isOpen={modal_Status} toggle={() => { Status(); }}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Change Status</h5>
              <button type="button" onClick={() => { setmodal_Status(false); }} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Col md={12}>
                {/* <p className="AvailableBalance">Available Balance : <b>€5600</b></p> */}
                <div className="mb-3">
                  <Label className="form-label">Status : </Label>
                  <select className="form-select">
                    <option>Pending</option>
                    <option>Approved</option>
                    <option>Cancelled</option>
                  </select>
                </div>
              </Col>
              <Col xs={12}>
                <div className="mb-3">
                  <label className="form-label">Transaction Information	:</label>
                  <textarea className="form-control" type="text" placeholder="Transaction Information" />
                </div>
              </Col>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => { setmodal_Status(false); }} aria-label="Close"> Update </button>
              <button type="button" className="btn btn-light" data-dismiss="modal" onClick={() => { setmodal_Status(false); }} aria-label="Close">Close</button>
            </div>
          </Modal>


          <Modal className="transation" size="lg" centered backdrop="static" isOpen={modal_Status1} toggle={() => { Status1(); }}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Withdrawal Details</h5>
              <button type="button" onClick={() => { setmodal_Status1(false); }} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mb-3">
              <div className="row">
                <div className="col-lg-6">
                  <p className="mb-1 border-box-1"><b>ID :</b> <span className="">1</span></p>
                  <p className="mb-1 border-box-1"><b>First Name :</b> <span className="">Kaushal</span></p>
                  <p className="mb-1 border-box-1"><b>Last Name :</b> <span className="">Sadhu</span></p>
                  <p className="mb-1 border-box-1"><b>Email ID :</b> <span className="">kaushal@domain.com</span></p>
                  <p className="mb-1 border-box-1"><b>Date :</b> <span className="">16/11/2023 | 15:30</span></p>
                  <p className="mb-1 border-box-1"><b>Amount :</b> <span className="">50,00 €</span></p>
                  <p className="mb-1 border-box-1"><b>Fees :</b> <span className="">10,00 € &nbsp;(10%)</span></p>
                  <p className="mb-1 border-box-1"><b>Total Amount :</b> <span className="">60,00 €</span></p>
                  <p className="mb-1 border-box-1"><b>Status :</b> <span className=""><span className="font-size-14 badge-soft-success badge bg-secondary rounded-pill">Approved</span></span></p>
                </div>
                <div className="col-lg-6">
                  <p className="mb-1 border-box-1"><b>Payment Detail :</b></p>
                  <p className="mb-1">Account Holder Name : Kaushal Sadhu <br /> IBAN No. : 56974562211 <br /> Routing No. : 1236644 <br /> BIC Code : BIC236544</p>
                  <p className="mb-2 border-box-1 mt-4"><b>Transaction Information :</b></p>
                  <p className="mb-1"><span>Bank of america transaction id #123665266 Payment transferred</span></p>
                </div>
              </div>
            </div>
          </Modal>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default withTranslation()(ReferralReward);